var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  border-radius: 0;\n  @media (min-width: 992px) {\n    width: ', ';\n  }\n  border: ', ';\n  background-color: ', ';\n  &:focus {\n    border: ', ';\n    box-shadow: none;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n'], ['\n  width: 100%;\n  border-radius: 0;\n  @media (min-width: 992px) {\n    width: ', ';\n  }\n  border: ', ';\n  background-color: ', ';\n  &:focus {\n    border: ', ';\n    box-shadow: none;\n  }\n  &::placeholder {\n    color: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme';

export var errorStyles = {
  border: function border(_ref) {
    var errors = _ref.errors,
        touched = _ref.touched,
        name = _ref.name;
    return errors[name] && touched[name] && '1px solid ' + Theme.colors.danger;
  },
  background: function background(_ref2) {
    var errors = _ref2.errors,
        touched = _ref2.touched,
        name = _ref2.name;
    return errors[name] && touched[name] && '' + Theme.colors.dangerLight;
  },
  focusBorder: function focusBorder(_ref3) {
    var errors = _ref3.errors,
        touched = _ref3.touched,
        name = _ref3.name;
    return errors[name] && touched[name] ? '2px solid ' + Theme.colors.danger : '2px solid ' + Theme.colors.lightBlue;
  }
};

export var StyledInputField = styled.input.attrs({
  className: 'form-control'
})(_templateObject, function (props) {
  return props.fw ? '100%' : '50%';
}, errorStyles.border, errorStyles.background, errorStyles.focusBorder, Theme.colors.blueGrey);

var InputField = function InputField(_ref4) {
  var errors = _ref4.errors,
      touched = _ref4.touched,
      name = _ref4.name,
      placeholder = _ref4.placeholder,
      type = _ref4.type,
      onChange = _ref4.onChange,
      onBlur = _ref4.onBlur,
      className = _ref4.className,
      fw = _ref4.fw,
      value = _ref4.value,
      disabled = _ref4.disabled;
  return React.createElement(StyledInputField, { errors: errors, touched: touched, name: name, placeholder: placeholder, type: type, onChange: onChange, onBlur: onBlur, className: className, fw: fw, value: value || '', disabled: disabled });
};

InputField.defaultProps = {
  errors: {},
  touched: {},
  type: 'text'
};

InputField.propTypes = process.env.NODE_ENV !== "production" ? {
  errors: PropTypes.object,
  touched: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.any,
  fw: PropTypes.bool,
  value: PropTypes.any,
  disabled: PropTypes.bool
} : {};

export default InputField;